import { lazy, Suspense, useContext } from 'react';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { ExternalSearchAwaitingDispatch } from '~/apps/smartsend/lib/consts/ListyConsts';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import useGoto from '~/hooks/use-goto';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const Listy = lazy(() => import('~/apps/smartsend/components/smartsend/listy/Listy'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { goTo } = useGoto();
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);

  useOnLoad(() => {
    const title = t('MARKETPLACE_TRACKING_PAGE_TITLE', { defaultValue: 'Marketplace Tracking' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SMARTSEND });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.AwaitingDispatch }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.AwaitingDispatch
      }
    });
  });

  return (
    <Suspense>
      <Listy initialTab={ExternalSearchAwaitingDispatch} isXs={isXs} goTo={goTo} />
    </Suspense>
  );
}

Component.displayName = 'SmartSend: Marketplace Tracking';
